<template>
    <q-card :inline="inline" :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver}]"
            :style="style"
            ref="card">
        <q-card-title class="title">
            <div v-if="! inEdit">{{localModel.label}}</div>
            <q-input v-else v-model="localModel.label"></q-input>
        </q-card-title>

        <q-card-media class="media q-pa-md">
            <drop-area
                v-if="inEdit"
                style="position: relative"
                class="q-pa-md"
                @dropped="dropShort">

                <template
                    v-if="localModel.thumbUrl || localModel.shortMovieUrl || localModel.audioUrl">
                    Krótki film, obrazek lub audio:
                    <generic-viewer
                        :src="localModel.thumbUrl || localModel.shortMovieUrl || localModel.audioUrl"/>

                    <q-btn
                        icon="delete"
                        dense
                        flat
                        class="absolute-top-right"
                        style="right: 0px; top: 10px;"
                        @click="clearShortMovie"/>

                </template>
                <template v-else>
                    Przeciągnij tu krótki film, obrazek lub audio
                </template>
            </drop-area>
            <template v-else>
                <generic-viewer
                    :src="localModel.thumbUrl || localModel.shortMovieUrl || localModel.audioUrl"/>
            </template>
        </q-card-media>

<!--        <q-card-media class="media q-pa-md">-->
<!--            <drop-area-->
<!--                class="q-pa-md"-->
<!--                style="position: relative;"-->
<!--                v-if="inEdit"-->

<!--                @dropped="drop">-->
<!--                <template v-if="localModel.movieUrl">-->
<!--                    Długi film:-->
<!--                    <generic-viewer :src="localModel.movieUrl"/>-->

<!--                    <q-btn-->
<!--                        icon="delete"-->
<!--                        dense-->
<!--                        flat-->
<!--                        class="absolute-top-right"-->
<!--                        style="right: 0px; top: 10px;"-->
<!--                        @click="clearTopMedia"/>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                    Przeciągnij film-->
<!--                </template>-->
<!--            </drop-area>-->
<!--            <template v-else-->
<!--                      class="q-pa-md"-->
<!--                      style="position: relative;"-->
<!--                      @dropped="drop">-->
<!--                <generic-viewer :src="localModel.movieUrl"/>-->
<!--            </template>-->
<!--        </q-card-media>-->










        <q-card-main class="main">
            <p v-if="! inEdit" v-html="localModel.description"></p>
            <textarea
                rows="10"
                v-if="inEdit && localModel.description != null"
                v-model="localModel.description"
                class="description"/>

            <drop-area @dropped="badgeDropped" v-if="inEdit">
                <div v-for="badgeId in localModel.badges"
                     :key="badgeId"
                     style="display: inline-block; position: relative;"
                     class="q-ma-sm">
                    <image-viewer
                        v-if="$store.state.RS.badge === 'fetch_done'"
                        :src="$store.getters.badge.find(b => b.badgeId === badgeId).thumbUrl"
                        style="width: 50px; height: 50px"/>
                    <q-btn
                        icon="delete"
                        dense
                        flat
                        class="absolute-top-right"
                        style="right: -20px; z-index: 10"
                        @click="removeBadge(badgeId)"/>
                </div>
                <br v-if="(localModel.badges || []).length"/>
                Przeciągnij tu odznaki
            </drop-area>
            <div v-else>
                <div v-for="badgeId in (localModel.badges || [])"
                     :key="badgeId"
                     style="display: inline-block; position: relative;"
                     class="q-ma-sm">
                    <image-viewer v-if="$store.state.RS.badge === 'fetch_done'"
                                  :src="$store.getters.badge.find(b => b.badgeId === badgeId).thumbUrl"
                                  style="width: 50px; height: 50px"/>
                </div>
            </div>

            <div v-if="inEdit && showStartDelayedDays">
                <q-field label="Wystartuj krokomierze po dniach:">
                    <q-input type="number" v-model="localModel.extras.startDelayedDays"></q-input>
                </q-field>
            </div>
            <div v-if="inEdit && showLinkToRoadmap">
                <q-field label="Link do mapy drogi">
                    <q-select
                        v-model="localModel.extras.externalLink"
                        :inline="true"
                        :options="externalLinks"
                    />
                </q-field>
            </div>
            <div v-if="inEdit && showMinNumberOfSteps">
                <q-field label="Minimalna ilość kroków:">
                    <q-input type="number" v-model="localModel.extras.stepometer.minNumberOfSteps"></q-input>
                </q-field>
            </div>
            <div v-if="inEdit && showAverageSpeed">
                <q-field label="Minimalna średnia prędkość:">
                    <q-input type="number" v-model="localModel.extras.stepometer.averageSpeed"></q-input>
                </q-field>
            </div>


            <div class="badges q-ma-sm text-right" v-if="showOpt">
                <template v-if="! isBasePole">
                    <q-icon :disabled="! inEdit" v-if="localModel.opt" size="30px" name="check_box" class="q-ma-sm" @click.native="localModel.opt = !localModel.opt"/>
                    <q-icon :disabled="! inEdit" v-if="! localModel.opt" size="30px" name="check_box_outline_blank" class="q-ma-sm" @click.native="localModel.opt = !localModel.opt"/>
                </template>
            </div>


            <q-field label="Kolor tła" v-if="inEdit">
                <q-color format-model="hex" v-model="localModel.backgroundColor"/>
            </q-field>
        </q-card-main>

        <q-card-actions v-if="!inEdit" align="end" class="actions">
            <q-btn flat round icon="delete" @click="confirmAndDelete"/>
        </q-card-actions>

        <q-card-actions v-if="inEdit && showDeleteOption" align="end" class="actions"
                        @dragover.native.prevent="dragover"
                        @dragleave.native="dragleave"
                        @dragenter.native="dragenter"
                        @drop.native="dropBackground">
            <q-btn flat round icon="delete" @click="emitDelete" v-if="! isBasePole"/>
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import QColor from 'quasar-framework/src/components/color/QColor'
    import DropArea from '../DropArea'
    import ImageViewer from './viewers/ImageViewer'
    import { QSelect } from 'quasar-framework'

    export default {
        name: 'TaskComponent',
        components: {
            ImageViewer,
            DropArea,
            QColor,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
            QSelect
        },
        props: {
            model: Object,
            editable: Boolean,
            inEdit: Boolean,
            inline: Boolean,
            isBasePole: Boolean,
            showOpt: {
                type: Boolean,
                default: true
            },
            showDeleteOption: {
                type: Boolean,
                default: true
            },
            showStartDelayedDays: {
                type: Boolean,
                default: false
            },
            showLinkToRoadmap: {
                type: Boolean,
                default: false
            },
            showMinNumberOfSteps: {
                type: Boolean,
                default: false
            },
            showAverageSpeed: {
                type: Boolean,
                default: false
            }
        }, //['model', 'editable', 'inEdit', 'inline', 'isBasePole'],
        methods: {
            confirmAndDelete () {
                if (! this.localModel.isNew) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie zadania`,
                        message: `Czy na pewno usunąć zadanie ${this.localModel.label}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('deleteTask', this.localModel).then(() => {
                            this.$emit('deleted')
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('deleted')
                }
            },
            emitDelete () {
                this.$emit('deleted')
            },
            clearTopMedia() {
                 this.localModel.movieUrl = undefined
            },
            clearShortMovie() {
                this.localModel.shortMovieUrl = this.localModel.thumbUrl = this.localModel.audioUrl = undefined
            },
            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            drop (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        switch (tasklet.type) {
                            case 'video':
                                this.localModel.movieUrl = tasklet.src
                                break;

                        }
                    } catch (ee) {
                        // ...
                    }

                    this.draggingOver = false
                }
            },
            dropShort (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        switch (tasklet.type) {
                            case 'video':
                                this.$set(this.localModel, 'shortMovieUrl', tasklet.src);
                                this.localModel.audioUrl = null
                                this.localModel.thumbUrl = null
                                break;
                            case 'picture':
                                this.localModel.audioUrl = null
                                this.localModel.movieUrl = null
                                this.localModel.thumbUrl = tasklet.src
                                break;
                            case 'audio':
                                this.localModel.audioUrl = tasklet.src
                                this.localModel.movieUrl = null
                                this.localModel.thumbUrl = null
                                break;
                        }
                    } catch (ee) {
                        // console.error(ee)
                    }

                    this.draggingOver = false
                }
            },
            dropBackground (e) {
                if (this.inEdit) {
                    try {
                        this.$set(this.localModel, 'backgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                    } catch (ee) {
                        // ...
                    }
                }
            },
            save () {

            },
            fetch () {
                this.$store.dispatch('fetchTask', this.model.poleStepTaskId)
            },
            fetchDetailsIfNecessary () {
                if (!this.localModel.isNew) {
                    this.fetch()
                }
            },
            badgeDropped (e) {
                let droppedModel;

                try {
                    droppedModel = JSON.parse(e.dataTransfer.getData('text'))
                } catch (ee) {
                    // console.error(ee)
                }

                if (droppedModel && droppedModel.type === 'badge') {
                    if (this.localModel.badges === undefined) {
                        this.$set(this.localModel, 'badges', [])
                    }

                    if (this.localModel.badges.indexOf(droppedModel.badgeId) === -1) {
                        this.localModel.badges.push(droppedModel.badgeId)
                    }
                }
            },
            removeBadge (badgeId) {
                this.localModel.badges = this.localModel.badges.filter(id => id !== badgeId)
            }

        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
                externalLinks: [
                    {label: 'Brak', value: undefined},
                    {label: 'Twój cel', value: 'w4l://roadmap/0'},
                    {label: 'Zasoby', value: 'w4l://roadmap/1'},
                    {label: 'Wsparcie', value: 'w4l://roadmap/2'},
                    {label: 'Kiedy', value: 'w4l://roadmap/3'},
                    {label: 'Motywatory', value: 'w4l://roadmap/4'},
                    {label: 'Potrzeby', value: 'w4l://roadmap/5'},
                    {label: 'Przeszkody', value: 'w4l://roadmap/6'},
                ]
            }
        },
        mounted () {
            // this.fetchDetailsIfNecessary()
        },
        watch: {
            bgr (value) {
                if (value) {
                    this.localModel.backgroundColor = undefined
                }
            },
            bgrColor (value) {
                if (value) {
                    this.localModel.backgroundUrl = undefined
                }
            }
        },
        computed: {
            bgr () {
                return this.localModel.backgroundUrl
            },
            bgrColor () {
                return this.localModel.backgroundColor
            },
            localModel () {
                if (this.$store.state.tasks.filter(t => t.poleStepTaskId === this.model.poleStepTaskId).length > 0) {
                    return this.$store.state.tasks.find(t => t.poleStepTaskId === this.model.poleStepTaskId)
                }

                return this.model
            },
            fullModel () {
                return this.$store.state.tasks.find(t => t.poleStepTaskId === this.model.poleStepTaskId)
            },
            style () {
                let value = ''

                if (this.localModel.backgroundUrl) {
                    value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.localModel.backgroundUrl}); background-size: cover; `
                }

                if (this.localModel.backgroundColor) {
                    value += `background-color: ${this.localModel.backgroundColor}; `
                }

                return value
            },
        },
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
            height: 58px;
        }

        border-radius: 20px;
    }

    .card:not(.inEdit) {
        width: 350px;
        height: 500px;
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }

        .actions {
            display: none;
        }

        &:hover .actions {
            display: flex;
        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        .description {
            width: 100%;
            max-height: 200px;
        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

</style>
